<template>
  <div class="wg-row wg-xs-12">
    <div class="wg-col wg-xs-12 wg-lg-7">
      <h1 class="com-anm22-page-title">
        {{ $anm22.strLang(lang, 'Project staff', 'Dipendenti del progetto') }}
      </h1>
      <template v-if="!offline">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Type to add new users', 'Digita per aggiungere un utente') }}
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <!-- search bar with list -->
        <wg-search
            :placeholder="$anm22.strLang(lang, 'User', 'Utente')"
            :url="'user/getByNameInDevelopers'"
            :attachedData="{projectId: project.idWorldProject}"
            :clickFn="addUser"
            :filters="searchFilters"
            :debounceTime="2000"
        ></wg-search>
      </template>
      <!-- List of users -->
      <div class="vertical-height-div" style="height:20px;"></div>
      <div class="wg-row">
        <div class="wg-row" style="align-items:center;" v-for="(u, index) in users" :key="'u-' + index">
            <!-- <img 
                v-if="u.image !== '' || (u.fbId && u.fbId !== '' && u.fbId != 0)"
                :key="'u-'+index"
                :src="$anm22.getObjIcon(u, 'userDefault')"
                :title="u.name + ' ' + u.surname"
                class="com-anm22-app-img-fixed-height-l com-anm22-round"
                style="margin-right:5px;"
            >
            <div 
                v-else
                :key="'u-'+index"
                class="project-list-user"
                :title="u.name + ' ' + u.surname"
                style="width:22px;height:22px;border-radius:11px;padding-top:4px;margin:0 5px 0 0;"
            >
              {{ u.name.substring(0,1) + u.surname.substring(0,1) }}
            </div> -->
            <div 
                style="min-width:30px;width:30px;height:30px;margin-right:5px;">
              <world-object-icon
                  :type="'user'" 
                  :obj="u"
                  :isImg="true">
              </world-object-icon>
            </div>
            <div>
              <div class="com-anm22-app-text-m" style="font-weight:bold;">
                {{ u.name + " " + u.surname }}
              </div>
              <div class="vertical-height-div" style="height:2px;"></div>
              <div 
                  v-if="!offline"
                  class="display-flex" 
                  style="align-items:center;cursor:pointer;" 
                  @click="removeUser(u.idWorldUser)">
                <img class="com-anm22-app-img-fixed-height-s" :src="$anm22.icons.getWorldIcon('deleteRed')">
                <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
                <div class="com-anm22-app-text-m">
                  {{ $anm22.strLang(lang, 'Remove', 'Rimuovi') }}
                </div>
              </div>
            </div>
          <div class="vertical-height-div" style="height:10px;"></div>
        </div>
      </div>
    </div>
    <div class="wg-col wg-xs-none wg-lg-5 project-manage-help-box">
      <img :src="$anm22.icons.getWorldIcon('group')" />
      <div>
        <strong>{{$anm22.strLang(lang, 'Add users', 'Aggiungi utenti')}}</strong><br />
        {{$anm22.strLang(lang, '', "Dai accesso agli altri utenti del team che collaborano con te al progetto.")}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    data: Object
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      offline: state => state.offline.isOffline
    }),
    project() {
      return this.$store.getters['projects/get'](this.data.project.idWorldProject);
    },
    users() {
      let temp = [];
      this.project.users.forEach(userId => {
        let user = this.$store.getters['users/get'](userId);
        if(user){
          temp.push(user);
        }
      });
      return temp;
    },
    searchFilters() {
      return [
        user => !this.project.users.includes(user.id)
      ]
    }
  },
  methods: {
    addUser(idUser) {
      this.$http
        .post("/project/addUser", {
          projectId: this.project.idWorldProject,
          userId: idUser
        }, {
          withCredentials: true
        })
        .then(response => {
          Promise.all([
            this.$store.dispatch('projects/update', {
              vlf: this.$vlf('projects'),
              objs: response.data.projects
            }),
            this.$store.dispatch('users/update', {
              vlf: this.$vlf('users'),
              objs: [response.data.user]
            })
          ])
          .catch(error => console.log(error))
        })
        .catch(error => {
        });
    },
    removeUser(userId) {
      this.$http
        .post("/project/removeUser", {
          projectId: this.project.idWorldProject,
          userId: userId
        }, {
          withCredentials: true
        })
        .then(response => {
          Promise.all([
            this.$store.dispatch('projects/update', {
              vlf: this.$vlf('projects'),
              objs: response.data.projects
            })
          ])
          .catch(error => console.log(error))
        })
        .catch(error => {
        });
    }
  },
  created() {
    this.$http.get('project/users?idProject='+this.$route.params.id)
      .then(response => {
        this.$store.dispatch('users/update', {
          vlf: this.$vlf('users'),
          objs: response.data.projects
        })
        .then(() => {
          this.$Progress.finish();
        })
        .catch(error => {
          console.log(error);
        })
      })
      .catch(error => {
        //Recupero dal db offline
        this.$store.dispatch('users/load', this.$vlf('users'))
        .catch(error => console.log(error));
      });
  }
};
</script>

<style lang="scss" scoped>
</style>

